import Swiper from 'swiper';
import SwiperCore, { Navigation } from 'swiper/core';

SwiperCore.use([Navigation]);

export default class PricingSerwis {
  constructor() {
    this.container = document.querySelector('.pricing-swiper');
    this.swiper = null;
    this.mobileBreakpoint = window.matchMedia('(max-width: 1151px)');
  }

  init() {
    if (!this.container) {
      return;
    }

    this.handleBreakpoint(this.mobileBreakpoint);
    this.mobileBreakpoint.addEventListener('change', (e) => this.handleBreakpoint(e));
  }

  initSwiper() {
    if (this.swiper === null) {
      this.swiper = new Swiper('.pricing-swiper', {
        slidesPerView: 1,
        spaceBetween: 16,
        initialSlide: 1,
        centeredSlides: true,
        loop: false,
        navigation: {
          nextEl: '.pricing-swiper-next',
          prevEl: '.pricing-swiper-prev',
        },
      });
    }
  }

  destroySwiper() {
    if (this.swiper !== null) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }

  handleBreakpoint(e) {
    if (e.matches) {
      this.initSwiper();
    } else {
      this.destroySwiper();
    }
  }
}
